import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { axiosDelete, axiosGet, axiosPatch, axiosPost } from 'Redux/axiosHelper'
import {
  CommunitySchoolType,
  CommunitySchoolTypePayload,
} from 'types/settings/communityschool'

// fetch list of community schools
const getCommunitySchool = async () => {
  const response = await axiosGet(`v1/community-school`)
  return response.data
}

export const useGetCommunitySchool = () => {
  const communitySchools = useQuery<CommunitySchoolType[]>(
    ['community-schools'],
    getCommunitySchool,
    {
      enabled: false,
    },
  )
  return communitySchools
}

//add new school to list
const addCommunitySchool = async (payload: CommunitySchoolTypePayload) => {
  const response = await axiosPost(payload, `v1/community-school`)
  return response.data
}
export const useAddCommunitySchool = () => {
  const queryClient = useQueryClient()
  return useMutation(addCommunitySchool, {
    onSuccess: (newData: CommunitySchoolType) => {
      queryClient.setQueryData(
        ['community-schools'],
        (oldData: CommunitySchoolType[] | undefined) => {
          if (!oldData) return [newData]
          return [...oldData, newData]
        },
      )
    },
  })
}

//update school from list
const updateCommunitySchool = async ({
  id,
  payload,
}: {
  id: string
  payload: CommunitySchoolTypePayload
}) => {
  const response = await axiosPatch(payload, `v1/community-school/${id}`)
  return response.data
}
export const useUpdateCommunitySchool = () => {
  const queryClient = useQueryClient()
  return useMutation(updateCommunitySchool, {
    onSuccess: (updatedData: CommunitySchoolType) => {
      queryClient.setQueryData(
        ['community-schools'],
        (oldData: CommunitySchoolType[] | undefined) => {
          if (!oldData) return [updatedData]
          return oldData.map(item =>
            item._id === updatedData._id ? updatedData : item,
          )
        },
      )
    },
  })
}

// remove school from list
const deleteCommunitySchool = async (id: string) => {
  const response = await axiosDelete(`v1/community-school/${id}`)
  return response.data
}

export const useDeleteCommunitySchool = () => {
  const queryClient = useQueryClient()
  return useMutation(deleteCommunitySchool, {
    onSuccess: (deletedData: CommunitySchoolType) => {
      queryClient.setQueryData(
        ['community-schools'],
        (oldData: CommunitySchoolType[] | undefined) => {
          if (!oldData) return undefined
          return oldData.filter(item => item._id !== deletedData._id)
        },
      )
    },
  })
}
